import React from 'react';
import LoginLogo from '../../components/Login/LoginLogo.jsx';

export default class LogoCardWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        var self = this;
        var specifiedLogoParams = (this.props.logoOptions && this.props.logoOptions["default"]);
        var cardViewProps = {
            params: this.props.cardView.props.params ? this.props.cardView.props.params : null,
            value: this.state.value,
            onChange: specifiedLogoParams ?
                (
                    (evt) => {
                        this.setState({
                            selectedOptions: this.props.logoOptions[evt],
                            value: evt
                        });
                    }
                ) : null
        };
        var loginLogoProps = {
            params: specifiedLogoParams ? (
                {
                    params: this.props.logoOptions[this.state.value || "default"]
                }
            ) : (
                {
                    default: {
                        smallAtHeight: 840,
                        hideAtHeight: 720,
                        hideAtWidth: 380,
                        contentHeight: "451px",
                        largeScale: 1.3
                    }
                }
            )
        };
        this.card = React.cloneElement(
            this.props.cardView,
            cardViewProps
        );
        this.loginLogo = React.cloneElement(
            LoginLogo,
            loginLogoProps
        );
        var params = this.props.logoOptions[this.state.value || "default"];
        return (
            <div>
                {this.props.hidePanel ? (
                    <div>
                        <div className="col-sm-12">
                            <div className="new-login-page" style={{marginBottom: "-30px"}}>
                                <LoginLogo params={params}/>
                            </div>
                        </div>
                        <div className="row login-right-panel-content">
                            <div className="col-sm-12" style={{display: "table", width: "100%"}}>
                                <div className="new-login-page" style={{verticalAlign: "middle"}}>
                                    <div className="login-box" style={{backgroundColor: "unset"}}>
                                        {this.card}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="col-md-8 col-no-pad login-logo-column">
                            <div className="new-login-page">
                                <LoginLogo params={params}/>
                            </div>
                        </div>
                        <div className="row login-right-panel-content">
                            <div className="col-md-8 col-no-pad login-input"
                                style={{display: "table", width: "100%", height: "100vh"}}>
                                <div className="new-login-page"
                                    style={{display: "table-cell", verticalAlign: "middle"}}>
                                    <div className="login-box">
                                        {this.card}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// app/components/Login/LogoCardWrapper.jsx